import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import {
  LOGIN_SOURCE_CARD,
  LOGIN_SOURCE_PAGE,
  LOGIN_SOURCE_TTU
} from '../constants';

const Wrapper = styled.div`
  grid-column: span 10;
  ${({ $source }) => $source === LOGIN_SOURCE_PAGE && 'width: 464px'}
  ${mediaQuery.uptoTablet} {
    ${({ $source }) => $source === LOGIN_SOURCE_PAGE && 'width: 370px'}
  }
  ${mediaQuery.uptoMobile} {
    ${({ $source }) => $source === LOGIN_SOURCE_PAGE && 'width: 100%'}
    .dropdown-button {
      ${({ $source }) => $source === LOGIN_SOURCE_TTU && 'grid-column: span 10'}
    }
  }
  ${({ $source }) =>
    $source === LOGIN_SOURCE_CARD && `padding: ${Spacings.SPACING_8B}`}
`;

export default Wrapper;
